export const Rule = ({ label }) => (
  <div style={{
    display: 'flex', alignItems: 'center', gap: 14,
    color: 'var(--ink-4)', fontFamily: 'var(--font-mono)',
    fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase',
    margin: '0 0 28px 0',
  }}>
    <span style={{ flex: '0 0 8px', height: 8, borderRadius: 999, background: 'var(--primary)' }} />
    {label}
    <span style={{ flex: 1, height: 1, background: 'var(--line)' }} />
  </div>
);
